import { useContext } from 'react';
import { GrowIntelContext } from '../context/context';

export default function useCurrency() {
  const context = useContext(GrowIntelContext);
  if (context === null) {
    throw new Error(
      'useGrowintUser must be used within a GrowIntelContextProvider',
    );
  }
  return context.user?.country?.currency;
}
